import { useMutation } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export async function sendClientPortalNotification(
  axiosInstance: Promise<AxiosInstance>,
  { debtorId }: { debtorId: number },
) {
  const instance = await axiosInstance;

  return instance.post(`debtors/${debtorId}/send_client_portal_notification`);
}

export function useSendClientPortalNotification() {
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, { debtorId: number }>({
    mutationFn: ({ debtorId }) => sendClientPortalNotification(axiosInstance, { debtorId }),
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    { debtorId: number },
    'sendClientPortalNotification'
  >('sendClientPortalNotification', mutation);
}
